import r from 'render-dom';

import ProductCardSkeleton from '../ProductCard/SkeletonLayout';

export default function ProductListSkeletonLayout() {
    return (
        r.div([
            r(ProductCardSkeleton),
            r(ProductCardSkeleton),
            r(ProductCardSkeleton),
            r(ProductCardSkeleton),
            r(ProductCardSkeleton),
        ])
    );
}
